import React from 'react';
import styled from 'styled-components';
import { LipscoreReviewsInterface } from './../../Lipscore/types/LipscoreProductModel.types';
import LipscoreReviews from './../../Lipscore/LipscoreReviews';

const StyledReviewsTab = styled.div`
  display: flex;
  justify-content: center;
`;

const ReviewsTab = (lipscore: LipscoreReviewsInterface) => {
  return (
    <StyledReviewsTab>
      <LipscoreReviews
        productModel={lipscore.productModel}
        readOnly={true}
        />
    </StyledReviewsTab>
  );
};

export default ReviewsTab;
